import { useAppSelector } from "lib/store";
import React, { FormEvent, useEffect, useState } from "react";
import ModalTitle from "../ModalTitle";
import styles from './propertyUpgrade.module.css';
import TextInput from "../ContactUs/TextInput";
import TextArea from "../ContactUs/TextArea";
import {
  generalContactEmail,
  getActiveNotificationsMessagesById,
  notificationDismissAllInLocation,
  sendGeneralContactFormData,
} from "_slices/notifications";
import { useDispatch } from "react-redux";
import { useNotificationLocation } from "lib/hooks/useNotificationLocation";
import logEvent from "lib/ga/miscEvent"

type Props = {
  title: string,
  subTitle: string,
  emailTemplate: any, 
  emailSubject: any, 
  property: {
    name: string,
    address: object
  }, 
  closeModal : any
}

const PropertyUpgrade = ({ title, subTitle, emailTemplate, emailSubject, property, closeModal }: Props) => {
  title = title || "Schedule a Call";
  subTitle = subTitle || "";

  let [name, setName] = useState<string>();
  let [email, setEmail] = useState<string>();
  let [phone, setPhone] = useState<string>();
  let [company, setCompany] = useState<string>();
  let [message, setMessage] = useState<string>();
  let notification_id = "MODAL_CONTACT_FORM";

  const [sendSuccess, activeNotifications] = useNotificationLocation(notification_id);

  let dispatch = useDispatch();

  useEffect(() => {
    dispatch(notificationDismissAllInLocation(notification_id));

    return () => {
      dispatch(notificationDismissAllInLocation(notification_id));
    };
  }, []);

  function formSubmit(e: FormEvent) {
    e.preventDefault();
    logEvent({
      category: "Property Upgrade",
      action: "Email sent",
      label: `Property: ${property.name}`,
    });
    dispatch(notificationDismissAllInLocation(notification_id));
    let payload: sendGeneralContactFormData = {
      data: {
        name,
        email,
        phone,
        company,
        message
      },
      template: emailTemplate ? emailTemplate : 'retail',
      subject: emailSubject,
      notification_handle: notification_id
    }

    dispatch(generalContactEmail(payload));
  }
  return (
    <>
      <ModalTitle title={title} subTitle={subTitle} />
      <div className={styles.PropertyContainer}>
        <div>{property.name}</div>
        <div>
          {['line1', 'line2', 'town_name', 'postcode'].map((k) => property.address[k]).filter(Boolean).join(', ')}
        </div>
      </div>
      {!sendSuccess &&
        activeNotifications &&
        activeNotifications.map((id) => {
          return <NotificationMessage key={id} id={id} />;
        })}
      <div className={`${styles.FormWrapper} ${sendSuccess ? styles.FormWrapperSuccess : ''} `}>
        <div className={styles.SuccessContainer}>
          <div className={`${styles.SuccessMessage} ${sendSuccess ? styles.SuccessMessageShow : ''}`}>
            <div>Thank You! Your message has been submitted</div>
            <p>A member of our team will be in contact shortly</p>
            <button className={styles.FancyButton} onClick={closeModal}>Close</button>
          </div>
        </div>
        <form className={styles.ContactUsFormGrid} onSubmit={(e) => formSubmit(e)}>
          <TextInput name="name" label="Full Name*" value={name} onInputChange={(e) => setName(e)} required={true} />
          <TextInput name="email" label="Email Address*" onInputChange={(e) => setEmail(e)} required={true} value={""} showText={false} />
          <TextInput name="phone" label="Phone Number*" onInputChange={(e) => setPhone(e)} required={true} value={""} showText={false} />
          <TextInput name="company" label="Company name" onInputChange={(e) => setCompany(e)} value={""} showText={false} />
          <div className={styles.MessageContainer}>
            <TextArea name="message" label="Message*" onInputChange={(e) => setMessage(e)} required={true} value={""} extraClass={undefined} showText={false} />
          </div>
          <div className={styles.ButtonContainer}>
            <button className={styles.FancyButton} type="submit">Submit</button>
          </div>
        </form>
      </div>
    </>
  );
};

export default PropertyUpgrade;

interface NotificationMessageProps {
  id: string;
}
const NotificationMessage = ({ id }: NotificationMessageProps) => {
  let messages = useAppSelector((state) => getActiveNotificationsMessagesById(id, state));

  return (
    <div className={styles.AlertDanger} key={id}>
      {messages.map((message) => {
        return <div key={id}>{message}</div>;
      })}
    </div>
  );
};
